import { Pillar } from '@interfaces/pillar';
import { BaseProcess } from '@interfaces/Process';

export class IProcess extends BaseProcess {
    minAuditedsByAuditor: number;
    maxAuditedsByAuditor: number;
    auditedGoal: Frequency;
    // auditorGoal: Frequency;
    remainderDays?: number;

    constructor () {
        super(Pillar.EHSS);

        this.minAuditedsByAuditor = 1;
        this.maxAuditedsByAuditor = 1;
        this.auditedGoal = { times: 1, type: FrequencyType.MONTHS };
        // this.auditorGoal = { times: 1, type: FrequencyType.MONTHS };
    }
}

export interface Frequency {
    times?: number;
    type?: FrequencyType;
}
export enum FrequencyType {
    DAYS = 1,
    MONTHS = 2,
    YEARS = 3
}


